import { ORG_APIS } from "@/api_framework/api_config";
import { IOrgServicesListResponse } from "@/api_framework/api_modals/Org";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setOrgServices } from "@/app_redux/reducers/static_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

const normalizeServicesData = (data: any) => {
  if (Array.isArray(data)) return data;

  const serviceTypes = data?.service_types ?? {};
  return Object.values(serviceTypes).flatMap((serviceType: any) =>
    (serviceType?.services ?? []).map((service: any) => ({
      ...service,
      service_type_id: serviceType?.id ?? "",
      service_type_name: serviceType?.name ?? "",
    })),
  );
};

export const useOrgServicesListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(async () => {
    dispatch(
      setLoading({
        key: "isOrgServicesInProgress",
        status: true,
      }),
    );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(ORG_APIS?.SERVICES_LIST?.baseURL ?? "", {
          params: {
            filter_type: "all",
          },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IOrgServicesListResponse>) => {
          if (res.data.status === true) {
            const finalData = normalizeServicesData((res.data as any)?.data);
            dispatch(
              setOrgServices({
                data: finalData,
              }),
            );
            dispatch(
              setLoading({
                key: "isOrgServicesInProgress",
                status: false,
              }),
            );
          } else {
            dispatch(
              setOrgServices({
                data: [],
              }),
            );
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e)
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
